import { gql } from "@apollo/client";


export const lookupCountryQuery = gql`
  query countries {
    countries @rest (type: "eventPayload", path: "/public/countries.json") {
      eventPayload {
        countries {
          countryCode
          countryName
          states {
            stateCode
            stateName
          }
        }
      }
    }
  }
`;